import { render, staticRenderFns } from "./ReviewGallery.vue?vue&type=template&id=ea51ba0e&scoped=true&"
import script from "./ReviewGallery.vue?vue&type=script&lang=ts&"
export * from "./ReviewGallery.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewGallery.vue?vue&type=style&index=0&id=ea51ba0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea51ba0e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCImage: require('/opt/build/repo/apps/shop/components/FCImage.vue').default})
